import { UITable } from '../../components/table/ui-table.js';
import { setAttributes } from '../../../shared-components/global/render-api.js';
import { Digest } from '../../global/index.js';

/**
 * @memberof SharedComponents
 * @classdesc Class for ui-table info plugin.
 * @alias UITableInfo
 * @implements {ComponentPlugin}
 * @param {HTMLTableElement} target Target instance.
 */
class UITableInfo {
    constructor(target) {
        this.target = target;
    }

    /**
     * @private
     */
    applyA11y() {
        // If there is a thead, we assume that everything is correct.
        if (this.target.table.tHead) {
            return;
        }

        let groupCellID = '';
        let headerRowIndex = 0;
        let rowIndex = 0;

        for (const body of this.target.table.tBodies) {
            for (const row of body.rows) {
                if (row.cells.length === 1) {
                    groupCellID = `${Digest.randomId()}-header-${headerRowIndex}`;
                    setAttributes(row.cells[0], {
                        id: groupCellID,
                        scope: 'colgroup',
                    });
                    headerRowIndex++;
                } else if (row.cells.length > 1) {
                    setAttributes(row.cells[0], {
                        id: `${groupCellID}-${rowIndex}`,
                        headers: groupCellID,
                        scope: 'row',
                    });
                    for (let i = 1; i < row.cells.length; i++) {
                        row.cells[i].setAttribute(
                            'headers',
                            [groupCellID, `${groupCellID}-${rowIndex}`].join(
                                ' '
                            )
                        );
                    }
                }
                rowIndex++;
            }
        }
    }

    /**
     * @inheritDoc
     */
    render() {
        this.target.table.classList.add('-info');
        this.applyA11y();
    }
}

UITable.registerPlugin('info', UITableInfo);

export { UITableInfo };
